module.exports = __webpack_public_path__ + "img/icon-cross.69b6e3bb.svg";